export function addMiscSection(bld, props) { props.miscPrices.map(m => { if (!m.publicNote && !m.extendedPrice)
    return; bld.addSection({ title: m.name, note: [m.publicNote], includeIfNoRows: true, subTotal: m.extendedPrice, miscSubCategory: m.name, categories: [] }, [], [], [m]); }); }
